'use client';

import { useChoice, useFilter } from '@liquorice/next-search';
import * as styles from '../PageHeader/PageHeader.css';
import Btn from '../ui/Btn';
import Container from '../ui/Container';
import Grid from '../ui/Grid';

const options = [
  { value: 'article', label: 'News' },
  { value: 'event', label: 'Event' },
  { value: 'page', label: 'Page' },
];

export function EntrySwitch() {
  const choice = useChoice({ name: 'section' });

  useFilter({
    id: 'section',
    callback: (variables, section) => {
      if (section?.length === 0) return variables;
      return { ...variables, section };
    },
  });

  return (
    <Container>
      <Grid>
        <Grid.Col sm={8} cx={{ display: 'flex', direction: 'row', columnGap: '6xs' }}>
          {options.map((option) => (
            <Btn
              color="white"
              disableHover
              key={option.value}
              className={styles.eventBodyToggleButton}
              onClick={() => choice.setValue(option.value)}>
              {option.label}
            </Btn>
          ))}
        </Grid.Col>
      </Grid>
    </Container>
  );
}
